import {
  Account,
  AccountStateKey,
  AccountStatus,
  AccountType,
  AssetClass,
  TradingSystem,
} from '@monorepo/types';

/**
 * Default Account Object
 *
 * Used as a fallback when hooks require a non-null Account parameter
 * but the actual account data might be null (e.g., during loading or error states).
 *
 * This ensures React hooks are called consistently while maintaining type safety.
 */
export const DEFAULT_ACCOUNT: Account = {
  _id: '',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  userId: '',
  purchaseId: '',
  programId: '',
  tradingSystem: TradingSystem.MetaTraderFive,
  tsAccount: '',
  tsAccountId: '',
  tsUserId: '',
  status: AccountStatus.Active,
  type: AccountType.Evaluation,
  state: {
    [AccountStateKey.Terminated]: false,
    [AccountStateKey.DailyPause]: false,
    [AccountStateKey.DailyLoss]: false,
    [AccountStateKey.Target]: false,
    [AccountStateKey.Expired]: false,
  },
  expireDate: new Date(),
  boosters: [],
  level: 0,
  assetClass: AssetClass.Forex,
} as Account;
